import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div data-testid="not-found-page" className="bg-slate-900 text-white">
    <div className="max-w-3xl mx-auto px-6 py-28 md:py-36">
      <div className="text-xs font-bold tracking-[0.18em] uppercase text-slate-500 mb-6">
        Error 404
      </div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight">
        That page isn't here.
      </h1>
      <p className="text-base md:text-lg text-slate-400 mt-6 leading-relaxed">
        The link may be mistyped, or the page may have moved. Everything below is a good
        place to pick up from.
      </p>
      <div className="mt-10 grid sm:grid-cols-2 gap-3">
        {[
          ['/', 'Home'],
          ['/why-safe', 'Why SAFE'],
          ['/council', 'The Council'],
          ['/safe-labs/verification-readiness', 'Verification Readiness Programme'],
          ['/directory', 'Directory'],
          ['/open-letter', 'Open Letter'],
        ].map(([to, label]) => (
          <Link
            key={to}
            to={to}
            data-testid={`not-found-link-${to.replace(/\//g, '-')}`}
            className="border border-slate-700 hover:border-white px-5 py-4 text-sm font-medium transition-colors"
          >
            {label}
          </Link>
        ))}
      </div>
      <p className="text-sm text-slate-500 mt-10">
        Still stuck? Write to{' '}
        <a href="mailto:safe@safestandard.ai" className="text-white underline underline-offset-4 hover:no-underline">
          safe@safestandard.ai
        </a>.
      </p>
    </div>
  </div>
);

export default NotFoundPage;
